<template>
  <Select
    :auto-filter-focus="hasSearch"
    :class="$style.versatileSelect"
    :disabled="disabled"
    :filter="hasSearch"
    :model-value="modelValue"
    :options="options"
    :option-label="optionLabel"
    :option-value="optionValue"
    :placeholder="placeholder"
    :pt="{ overlay: { style: { height: '292px', width: '600px' } } }"
    @update:model-value="emits('update:modelValue', $event)"
  >
    <template #header>
      <slot name="header" />
    </template>
  </Select>
</template>

<script setup lang="ts">
import Select from "primevue/select";

import { PropType } from "vue";

const emits = defineEmits(["update:modelValue"]);

defineProps({
  modelValue: {
    type: String as PropType<string | null>,
    default: null,
  },
  hasSearch: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  options: {
    type: Array as PropType<Array<{ label: string; value: string }>>,
    required: true,
  },
  optionLabel: {
    type: String,
    required: true,
  },
  optionValue: {
    type: String,
    required: true,
  },
  placeholder: {
    type: String,
    default: "Select an option",
  },
});
</script>

<style module lang="scss">
.versatileSelect {
  width: 100%;
}
</style>
